import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../../lib/helpers';

import Button from '../../../../components/Button/Button';
import HelpErrorTextsTemplate from '../../../../components/HelpErrorTextsTemplate/HelpErrorTextsTemplate';

import { CloseIcon, UploadedFileIcon } from '../../../../images/shapes';

import { useFieldContext } from '../../../form';
import { useFieldErrors } from '../../../useFieldErrors';

interface FileSelectorItemProps {
  /**
   * idx
   */
  idx: number;
  /**
   * On file remove callback
   */
  onRemove: (idx: number) => void;
  /**
   * File name
   */
  fileName: string;
  /**
   * File size
   */
  fileSize: string;
  /**
   * Is the file selector item disabled
   */
  disabled?: boolean;
  /**
   * File selector item testId
   */
  testId?: string;
}

const FileSelectorItem = ({
  idx,
  fileName,
  fileSize,
  onRemove,
  disabled = false,
  testId = '',
}: FileSelectorItemProps) => {
  const field = useFieldContext<File>();
  const errors = useFieldErrors(field.name);

  return (
    <div>
      <div
        className={twMerge(
          'flex items-center rounded-md border border-slate-100 px-4 py-2 dark:border-slate-800',
          !!errors?.length && 'border-red dark:border-red',
        )}
        {...getTestProps(testId, 'file-selector-item')}
      >
        <UploadedFileIcon className="w-7 h-7 mr-3" />
        <div className="flex flex-col max-w-full min-w-0">
          <span className="truncate mr-1">{fileName}</span>
          <span className="text-sm text-slate-400">{fileSize}</span>
        </div>
        <Button
          buttonColor="borderless"
          additionalClasses="w-fit h-full ml-auto hover:text-blue"
          onClick={() => onRemove(idx)}
          disabled={disabled}
        >
          <CloseIcon className="w-3 h-3" />
        </Button>
      </div>
      <HelpErrorTextsTemplate error={errors} testId={testId} />
    </div>
  );
};

export default FileSelectorItem;
